import React, { Component } from "react";
import { isLigneReportNul } from "../../../utils/tools";

const styles = {
  document: {
    color: "#000000",
    fontFamily: "sans-serif",
    fontSize: "9pt",
  },
  header: {
    marginBottom: "12pt",
    textAlign: "center",
  },
  title: {
    fontSize: "18pt",
    margin: "0 0 6pt",
  },
  headerLine: {
    margin: "3pt 0",
  },
  accountTable: {
    borderCollapse: "collapse",
    fontSize: "8pt",
    marginBottom: "10pt",
    width: "100%",
  },
  cell: {
    border: "1px solid #000000",
    padding: "3pt",
    verticalAlign: "top",
  },
  accountHeader: {
    backgroundColor: "#d9d9d9",
    border: "1px solid #000000",
    fontSize: "9pt",
    padding: "4pt",
    textAlign: "left",
  },
  columnHeader: {
    backgroundColor: "#e6e6e6",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "center",
    verticalAlign: "middle",
  },
  amountCell: {
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  centerCell: {
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "center",
    verticalAlign: "top",
  },
  totalLabelCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
  },
  totalAmountCell: {
    backgroundColor: "#f2f2f2",
    border: "1px solid #000000",
    padding: "3pt",
    textAlign: "right",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
};

export default class ComptePDF extends Component {
  render() {
    const { lignesEcritures, dateDu, dateAu, compteDu, compteAu, comptes, soldeEvolutif } =
      this.props;

    // let totalDebit = 0;
    // let totalCredit = 0;
    // let totalSolde = 0;
    // let totalSoldeDebit = 0;
    // let totalSoldeCredit = 0;
    // lignesEcritures.forEach((ligne, i) => {
    //   totalDebit += parseFloat(ligne.ecriture_ligne_montant_debit);
    //   totalCredit += parseFloat(ligne.ecriture_ligne_montant_credit);
    // });

    // totalSolde = totalCredit - totalDebit;

    // if (totalSolde < 0) {
    //   totalSoldeDebit = totalSolde;
    // } else if (totalSolde > 0) {
    //   totalSoldeCredit = totalSolde;
    // }

    let totalDebitF = 0;
    let totalCreditF = 0;
    let totalSoldeF = 0;
    let totalSoldeDebitF = 0;
    let totalSoldeCreditF = 0;

    let soldeEv = 0;
    let soldeCompte = 0;

    return (
      <div style={styles.document}>
        {/* Titre */}
        <div style={styles.header}>
          <h1 style={styles.title}>Interrogation de compte</h1>
          <p style={styles.headerLine}>
            <span>
              <strong>
                {`Situation ${
                  dateDu ? "du " + dateDu.format("DD/MM/YYYY") + " " : ""
                }au ${dateAu.format("DD/MM/YYYY")}`}
              </strong>
            </span>
          </p>
          <p style={styles.headerLine}>
            <strong>
              Compte du{" "}
              {
                comptes.find((compte) => compte.compte_compte_general === compteDu)
                  .compte_compte_general
              }
              {" -  "}
              {comptes.find((compte) => compte.compte_compte_general === compteDu).compte_libelle}
            </strong>
          </p>
        </div>

        {/* boucle comptes + sort
        condition compteDu compteAu
        lignesEcrituresFiltered = filtre ligneEcriture (compte = compte) */}

        {comptes
          .filter((compte) => compte.compte_type_compte !== "A")
          .sort((a, b) => a.compte_compte_general - b.compte_compte_general)
          .map((compte, j) => {
            if (
              compte.compte_compte_general >= compteDu &&
              compte.compte_compte_general <= compteAu
            ) {
              const lignesEcrituresFiltered = lignesEcritures.filter(
                (e) => e.ecriture_ligne_compte_id === compte.compte_id
              );
              if (lignesEcrituresFiltered.length !== 0) {
                return (
                  <div key={j}>
                    <table style={styles.accountTable}>
                      <thead>
                        <tr>
                          <th colSpan="7" style={styles.accountHeader}>
                            <strong>
                              {" "}
                              {compte.compte_compte_general}
                              {" - "}
                              {compte.compte_libelle}
                            </strong>
                          </th>
                        </tr>
                        <tr>
                          <th width="5%" scope="col" style={styles.columnHeader}>
                            <strong>JRN</strong>
                          </th>
                          <th width="10%" scope="col" style={styles.columnHeader}>
                            <strong>DATE</strong>
                          </th>

                          <th width="43%" scope="col" style={styles.columnHeader}>
                            <strong> LIBELLE</strong>
                          </th>
                          <th width="12%" scope="col" style={styles.columnHeader}>
                            <strong>DEBIT </strong>
                          </th>
                          <th width="12%" scope="col" style={styles.columnHeader}>
                            <strong>CREDIT </strong>
                          </th>
                          <th width="12%" scope="col" style={styles.columnHeader}>
                            <strong>SOLDE </strong>
                          </th>
                          <th width="6%" scope="col" style={styles.columnHeader}>
                            <strong>LET </strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {lignesEcrituresFiltered.map((ligneF, i) => {
                          if (i === 0) {
                            totalDebitF = 0;
                            totalCreditF = 0;
                            totalDebitF += parseFloat(ligneF.ecriture_ligne_montant_debit);
                            totalCreditF += parseFloat(ligneF.ecriture_ligne_montant_credit);
                          } else {
                            totalDebitF += parseFloat(ligneF.ecriture_ligne_montant_debit);
                            totalCreditF += parseFloat(ligneF.ecriture_ligne_montant_credit);
                          }
                          if (i === lignesEcrituresFiltered.length - 1) {
                            totalSoldeDebitF = 0;
                            totalSoldeCreditF = 0;
                            totalSoldeF = totalCreditF - totalDebitF;
                            if (totalSoldeF < 0) {
                              totalSoldeDebitF = Math.abs(totalSoldeF);
                            } else if (totalSoldeF > 0) {
                              totalSoldeCreditF = totalSoldeF;
                            }
                          }
                          // Solde évolutif propre au compte de la section (ligneF.solde cumule tous les comptes)
                          if (i === 0) soldeCompte = 0;
                          soldeCompte +=
                            parseFloat(ligneF.ecriture_ligne_montant_debit) -
                            parseFloat(ligneF.ecriture_ligne_montant_credit);
                          soldeEv = soldeEvolutif ? soldeCompte : 0;
                          return (
                            <tr
                              key={i}
                              style={{ backgroundColor: i % 2 === 0 ? "#ffffff" : "#eeeeee" }}
                            >
                              <td width="5%" style={styles.centerCell}>
                                {ligneF.ecriture_journal_code}
                              </td>
                              <td width="10%" style={styles.centerCell}>
                                {ligneF.ecriture_date_ecriture}
                              </td>
                              <td width="43%" style={styles.cell}>
                                {ligneF.ecriture_ligne_libelle}
                              </td>
                              <td width="12%" style={styles.amountCell}>
                                {parseInt(ligneF.ecriture_ligne_montant_debit) !== 0 ||
                                isLigneReportNul(ligneF) ? (
                                  parseFloat(ligneF.ecriture_ligne_montant_debit).toLocaleString(
                                    "fr-FR",
                                    {
                                      style: "currency",
                                      currency: "EUR",
                                    }
                                  )
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td width="12%" style={styles.amountCell}>
                                {parseInt(ligneF.ecriture_ligne_montant_credit) !== 0 ||
                                isLigneReportNul(ligneF) ? (
                                  parseFloat(ligneF.ecriture_ligne_montant_credit).toLocaleString(
                                    "fr-FR",
                                    {
                                      style: "currency",
                                      currency: "EUR",
                                    }
                                  )
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td width="12%" style={styles.amountCell}>
                                {parseInt(soldeEv) !== 0 ? (
                                  parseFloat(soldeEv).toLocaleString("fr-FR", {
                                    style: "currency",
                                    currency: "EUR",
                                  })
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td width="6%" style={styles.centerCell}>
                                {ligneF.ecriture_ligne_lettrage}
                              </td>
                            </tr>
                          );
                        })}
                        <tr>
                          <td colSpan="3" width="58%" style={styles.totalLabelCell}>
                            <strong>TOTAL </strong>
                          </td>
                          <td width="12%" style={styles.totalAmountCell}>
                            {parseFloat(totalDebitF).toLocaleString("fr-FR", {
                              style: "currency",
                              currency: "EUR",
                            })}
                          </td>
                          <td width="12%" style={styles.totalAmountCell}>
                            {parseFloat(totalCreditF).toLocaleString("fr-FR", {
                              style: "currency",
                              currency: "EUR",
                            })}
                          </td>
                          <td width="12%" style={styles.totalAmountCell}></td>
                          <td width="6%" style={styles.totalAmountCell}></td>
                        </tr>
                        <tr>
                          <td colSpan="3" width="58%" style={styles.totalLabelCell}>
                            <strong>
                              SOLDE DU COMPTE {compte.compte_compte_general}
                              {" - "}
                              {compte.compte_libelle}{" "}
                            </strong>
                          </td>
                          <td width="12%" style={styles.totalAmountCell}>
                            {parseFloat(totalSoldeDebitF).toLocaleString("fr-FR", {
                              style: "currency",
                              currency: "EUR",
                            })}
                          </td>
                          <td width="12%" style={styles.totalAmountCell}>
                            {parseFloat(totalSoldeCreditF).toLocaleString("fr-FR", {
                              style: "currency",
                              currency: "EUR",
                            })}
                          </td>
                          <td width="12%" style={styles.totalAmountCell}></td>
                          <td width="6%" style={styles.totalAmountCell}></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                );
              }
            }
            return null;
          })}
      </div>
    );
  }
}
